import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1d7e4be9&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/views/extranet/isvIntroduction/index.scss?vue&type=style&index=0&id=1d7e4be9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7e4be9",
  null
  
)

export default component.exports